/* angular */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChipModule, SolValidatorModule, SolPaginationModule, SolarFormModule, SolModalModule } from '@solar/components';
import { NgbDropdownModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

/* ngx translate */
import { TranslateModule } from '@ngx-translate/core';

import { NotificationsComponent } from './notifications.component';
import { NotificationsBellComponent } from './notifications-bell.component';

import { MessagesService } from './services/messages.service';
import { NotificationService } from './services/notification.service';
import { ToasterService } from './services/toast/toast.service';
import { ExperienceService } from '../../services/experience.service';

@NgModule({
	imports: [
		ChipModule,
		CommonModule,
		HttpClientModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		NgbDropdownModule,
		SolarFormModule,
		SolValidatorModule,
		SolPaginationModule,
		SolModalModule,
		NgbModalModule,
		TranslateModule
	],
	exports: [
		NotificationsComponent,
		NotificationsBellComponent,
		TranslateModule
	],
	providers: [
		NotificationService,
		MessagesService,
		ToasterService,
		ExperienceService	
	],
	declarations: [
		NotificationsComponent,
		NotificationsBellComponent
	]
})

export class NotificationsModule {
	constructor() { }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/notifications/notifications.module.ts